"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debug = debug;
exports.info = info;
exports.warn = warn;
exports.error = error;
exports.addSink = addSink;
exports.removeSink = removeSink;
exports.removeAllSinks = removeAllSinks;
exports.addGlobalProperties = addGlobalProperties;
// eslint-disable-next-line no-restricted-imports
const Logger_1 = require("./Logger");
// the reference to the underlying logger will be maintained here, and only
// here. we do not want to expose it to the outside world just yet, so please
// DO NOT EXPORT this reference to logger. It should only be returned from
// functions defined in here.
let logger = Logger_1.Logger.create();
/*
 * The functions below are simple delegates to the underlying logger. This
 * is preferred over simply exporting the references to logger.* methods as
 * that would couple logger to all callsites, and it would force us to deal
 * scoping issues (e.g. having to use .bind()). This way, we have some space
 * to perform an additional logic we might want to, and we can benefit from
 * the lexical scoping of arrow functions.
 */
function debug(message, options) {
    logger.debug(message, options);
}
function info(message, options) {
    logger.info(message, options);
}
function warn(message, options) {
    logger.warn(message, options);
}
function error(message, options) {
    logger.error(message, options);
}
function addSink(sink) {
    logger = Logger_1.Logger.addSink(sink);
}
function removeSink(sink) {
    logger = Logger_1.Logger.removeSink(sink);
}
function removeAllSinks() {
    logger = Logger_1.Logger.removeAllSinks();
}
function addGlobalProperties(props) {
    logger.addGlobalProperties(props);
}
//# sourceMappingURL=Log.js.map